import { connect } from 'react-redux'
import WelcomeBack from './WelcomeBack'
import { logout } from './../../../../store/token/actions'

const mapDispatchToProps = (dispatch) => ({
  logout: () => dispatch(logout()),
})

export default connect(null, mapDispatchToProps)(WelcomeBack)


// WEBPACK FOOTER //
// ./src/pages/Login/LoginContinue/WelcomeBack/Container.js